if (customElements && !customElements.get('collection-product-grid')) {
  class CollectionProductGrid extends HTMLElement {
    connectedCallback() {
      this.tabsContainer = this.querySelector('[data-role="tabs-container"]');
      this.tabTriggers = this.querySelectorAll('[data-role="tab-trigger"]');
      this.tabContents = this.querySelectorAll('[data-role="tab-content"]');

      this.initTabs();
    }

    playCrispLoader(tabContainer) {
      if (!tabContainer) {
        console.error('Require: element tabContainer');
      }

      const elemCrispLoader = tabContainer.querySelector('crisp-loader');
      if (elemCrispLoader && !elemCrispLoader.classList.contains('is--loaded')) {
        elemCrispLoader?.restartAnimate?.();
      }
    }

    toggleActiveTab(tabId) {
      if (!this.tabTriggers.length || !this.tabContents.length) {
        console.warn('Not found: tab triggers or tab contents');
        return;
      }

      this.tabTriggers.forEach((trigger) => {
        trigger.classList.toggle('active', trigger.dataset.tabTriggerId === tabId);
      });

      this.tabContents.forEach((content) => {
        const isActive = content.dataset.tabContentId === tabId;
        content.classList.toggle('active', isActive);

        if (!isActive) return;

        content.animate(
          [{ opacity: 0 }, { opacity: 1 }],
          { duration: 300, easing: 'ease' }
        );

        this.playCrispLoader(content);
      });
    }

    bindTabEvents() {
      if (!this.tabsContainer) {
        console.warn('Not found:  [data-role="tabs-container"]');
        return;
      }

      this.tabsContainer.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-role="tab-trigger"]');
        if (!trigger) return;
        if (trigger.classList.contains('active')) return;

        const tabId = trigger.dataset.tabTriggerId;
        this.toggleActiveTab(tabId);
      });
    }

    initTabs() {
      this.bindTabEvents();

      if (!this.querySelector('[data-role="tab-trigger"].active') && this.tabTriggers.length > 0) {
        this.toggleActiveTab(this.tabTriggers[0].dataset.tabTriggerId);
      }
    }
  }

  customElements.define('collection-product-grid', CollectionProductGrid);
}